// extracted by mini-css-extract-plugin
module.exports = {"emptyBox":"style_emptyBox__k6dNH","description":"style_description__Cxx1H","btn":"style_btn__fKhHt","noFixed":"style_noFixed__GgyiR"};